module.exports = __webpack_public_path__ + "static/media/sticker-sheet-proof.a25ec298.png";